import { render, staticRenderFns } from "./FooterLoggedIn.vue?vue&type=template&id=35d8e638&scoped=true&"
import script from "./FooterLoggedIn.vue?vue&type=script&lang=js&"
export * from "./FooterLoggedIn.vue?vue&type=script&lang=js&"
import style0 from "./FooterLoggedIn.vue?vue&type=style&index=0&id=35d8e638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8e638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VFooter,VSpacer,VToolbarItems,VToolbarTitle})
